import { useSelector } from 'react-redux'
import { StyleBg } from './style'
import Helper from '@utils/helper'
import { User } from '@apis'
import PatientDetails from './patient'
import DoctorDetails from './doctor'
import { useEffect } from 'react'
const Details = () => {
  const state = Helper.getCallSession()
  const { data: user } = useSelector((state: any) => state.user)
  const { data: userAppointment } = useSelector(
    (state: any) => state.userAppointment,
  )
  const { receiver } = state
  const fetchData = async () => {
    if (user?.role == 'patient') {
      await User.find({
        id: receiver?.id,
        state: 'userAppointment',
      }).catch(() => {})
    } else {
      await User.appointments({
        id: receiver?.id,
      }).catch(() => {})
    }
  }
  useEffect(() => {
    if (!userAppointment?.id) {
      fetchData()
    }
  }, [])
  return (
    <StyleBg>
      {user?.role == 'doctor' ? <PatientDetails /> : <DoctorDetails />}
    </StyleBg>
  )
}

export default Details
